<template>
  <div class="anonymous">
    <FeaturedCoursesSlider
      :algoliaKeys="algoliaKeys"
      :isFreeTrialUser="isFreeTrialUser"
    />
    <Areas />
    <MetricCarousel
      v-for="metric in carouselMetrics"
      :key="`metric-${metric.name}-${metric.facet}`"
      :algoliaKeys="algoliaKeys"
      :metric="metric"
      :isTablet="isTablet"
      :isMobile="isMobile"
    />
    <article class="anonymous__carousels">
      <CarouselsByTags
        :isMobile="isMobile"
        :algoliaKeys="algoliaKeys"
        :isFreeTrialUser="isFreeTrialUser"
      />
    </article>
  </div>
</template>

<script>
import FeaturedCoursesSlider from '@/components/home/anonymous-view/FeaturedCoursesSlider.vue'
import Areas from '@/components/home/anonymous-view/Areas.vue'
import MetricCarousel from '@/components/home/MetricCarousel.vue'
import CarouselsByTags from '@/components/home/anonymous-view/CarouselsByTags.vue'

export default {
  name: 'AnonymousView',
  components: {
    FeaturedCoursesSlider,
    Areas,
    MetricCarousel,
    CarouselsByTags,
  },
  props: {
    algoliaKeys: {
      type: Object,
      required: true,
    },
    isFreeTrialUser: {
      type: Boolean,
      required: true,
    },
    isMobile: {
      type: Boolean,
      required: true,
    },
    isTablet: {
      type: Boolean,
      required: true,
    },
    windowWidth: {
      type: Number,
      required: true,
    },
    carouselMetrics: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss">
.anonymous {
  &__carousels {
    margin: 100px 0 0 0;
  }
}
</style>
